import { generalEnv } from '@nx-frontend/shared/env';

export function prepareFileItemUrl(itemUrl: string, host: string) {
  if (!itemUrl?.length || !host?.length) {
    return itemUrl;
  }
  const nimbuswebme = 'nimbusweb.me';
  const appNimbuswebMe = 'app.nimbusweb.me';
  if (itemUrl.includes(appNimbuswebMe)) {
    return itemUrl.replace(appNimbuswebMe, host);
  }
  if (itemUrl.includes(generalEnv.appNimbusDomain)) {
    return itemUrl.replace(generalEnv.appNimbusDomain, host);
  }
  if (itemUrl.includes(generalEnv.nimbusDomain)) {
    return itemUrl.replace(generalEnv.nimbusDomain, host);
  }
  if (itemUrl.includes(nimbuswebme)) {
    return itemUrl.replace(nimbuswebme, host);
  }
  return itemUrl;
}
